const store = {
    namespaced: true,
    state() {
        return {
            vacancies: [],
            activeVacancy: null,
            showModalActiveVacancy: false,
            showModalSendCv: false,
            showModalSendCvSuccess: false,
        }
    },
    getters: {
        getVacancies(state) {
            return state.vacancies
        },
        getActiveVacancy(state) {
            return state.activeVacancy
        },
        getShowModalActiveVacancy(state) {
            return state.showModalActiveVacancy
        },
        getShowModalSendCv(state) {
            return state.showModalSendCv
        },
        getShowModalSendCvSuccess(state) {
            return state.showModalSendCvSuccess
        },
    },
    mutations: {
        setVacancies(state, vacancies) {
            state.vacancies = vacancies
        },
        setActiveVacancy(state, vacancy) {
            state.activeVacancy = vacancy
        },
        setShowModalActiveVacancy(state, value) {
            state.showModalActiveVacancy = value
        },
        setShowModalSendCv(state, value) {
            return state.showModalSendCv = value
        },
        setShowModalSendCvSuccess(state, value) {
            return state.showModalSendCvSuccess = value
        }
    },
}

export default store